import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { CouchbaseTableDataset } from 'app/model/dataset/couchbase.dataset';
import { CouchbaseLinkedService } from 'app/model/linkedservice/couchbase.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const couchbaseTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(CouchbaseTableDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Couchbase_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(CouchbaseLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-couchbase'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['NoSQL']
};
